The page of advertisement brandings and their corresponding cursors.

This list may be empty.
